import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { api } from '../api';

const AdminContext = createContext(null);

export function AdminProvider({ children }) {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  const verify = useCallback(async () => {
    const token = localStorage.getItem('nb_admin_token');
    if (!token) { setLoading(false); return; }
    try { await api.adminVerify(); setIsAdmin(true); }
    catch { localStorage.removeItem('nb_admin_token'); setIsAdmin(false); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { verify(); }, [verify]);

  const login = async (email, password) => {
    const { token } = await api.adminLogin({ email, password });
    localStorage.setItem('nb_admin_token', token);
    setIsAdmin(true);
  };

  const logout = () => {
    localStorage.removeItem('nb_admin_token');
    setIsAdmin(false);
  };

  return (
    <AdminContext.Provider value={{ isAdmin, loading, login, logout }}>
      {children}
    </AdminContext.Provider>
  );
}

export function useAdmin() { return useContext(AdminContext); }
